import '../../Div/index.js';
import { jsx } from 'react/jsx-runtime';
import { Div } from '../../Div/Div.js';
const Quote = ({
  secondaryColor,
  css
} = {}) => {
  return function quote(node, children) {
    return /*#__PURE__*/jsx(Div, {
      as: "blockquote",
      display: "block",
      overflow: "hidden",
      color: secondaryColor,
      css: css || {
        marginBlockStart: '1em',
        marginBlockEnd: '1em',
        marginInlineStart: 40,
        marginInlineEnd: 40
      },
      children: children
    });
  };
};
export { Quote };
//# sourceMappingURL=Quote.js.map
